import * as React from "react";
import icon from "../ic_alert.svg";
const SvgComponent = (props) => (
  <img
    src={icon}
    alt="Danger"
    height={props.size || "48px"}
    width={props.size || "48px"}
    style={{ objectFit: "contain" }}
  />
);
export default SvgComponent;
